import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    IconButton,
    Flex,
} from "@chakra-ui/react";
import { DownloadIcon, CloseIcon } from "@chakra-ui/icons";

type ImagePreviewModalProps = {
    isOpen: boolean;
    onClose: () => void;
    image?: string;
};

const ImagePreviewModal = ({ isOpen, onClose, image }: ImagePreviewModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full">
            <ModalOverlay />
            <ModalContent
                w="100vw"
                h="100vh"
                maxW="100vw"
                maxH="100vh"
                m="0"
                bg="black"
                borderRadius="0"
            >
                <Flex
                    position="absolute"
                    top="1rem"
                    right="1rem"
                    gap="0.5rem"
                    zIndex={10}
                >
                    <IconButton
                        aria-label="Download"
                        icon={<DownloadIcon />}
                        colorScheme="whiteAlpha"
                        onClick={() => {
                            if (!image) return;
                            const link = document.createElement("a");
                            link.href = image;
                            link.download = "document.jpg";
                            link.click();
                        }}
                    />
                    <IconButton
                        aria-label="Close"
                        icon={<CloseIcon />}
                        colorScheme="whiteAlpha"
                        onClick={onClose}
                    />
                </Flex>

                <ModalBody
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    p={0}
                >
                    <img
                        src={image}
                        alt="Preview"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100vh",
                            objectFit: "contain",
                        }}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
export default ImagePreviewModal


